import { Component, Input, OnChanges } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { DAILY_REPORT_STATUSES, DailyReportCell, DayInfo, HOUR_SLOTS } from '../../../interfaces/daily-report.interface';

interface DailyReportRow {
  label: string;
  counts: number[];
  total: number;
}

@Component({
  selector: 'app-daily-report-table',
  standalone: true,
  imports: [MatCardModule],
  templateUrl: './daily-report-table.component.html',
  styleUrls: ['./daily-report-table.component.scss']
})
export class DailyReportTableComponent implements OnChanges {
  @Input() title: string = '';
  @Input() dayInfo: DayInfo | null = null;
  @Input() cells: DailyReportCell[] = [];

  statuses = DAILY_REPORT_STATUSES;
  rows: DailyReportRow[] = [];
  totalsRow: DailyReportRow = { label: 'Összesen', counts: [], total: 0 };

  // -1 = az összesítő sor, illetve az összesítő oszlop
  hoveredRow: number | null = null;
  hoveredCol: number | null = null;

  ngOnChanges(): void {
    this.buildRows();
  }

  onCellHover(rowIndex: number, colIndex: number): void {
    this.hoveredRow = rowIndex;
    this.hoveredCol = colIndex;
  }

  clearHover(): void {
    this.hoveredRow = null;
    this.hoveredCol = null;
  }

  private buildRows(): void {
    const statusIndex = new Map(this.statuses.map((status, index) => [status.value, index]));

    const hourlyCounts = new Map<number, number[]>();
    const otherCounts = new Array(this.statuses.length).fill(0);

    for (const hour of HOUR_SLOTS) {
      hourlyCounts.set(hour, new Array(this.statuses.length).fill(0));
    }

    for (const cell of this.cells) {
      const index = statusIndex.get(cell.cc_status);
      if (index === undefined) {
        continue;
      }

      const target = hourlyCounts.get(cell.hour_slot) ?? otherCounts;
      target[index] += cell.call_count;
    }

    this.rows = HOUR_SLOTS.map(hour => this.toRow(this.formatHourLabel(hour), hourlyCounts.get(hour)!));

    // Az órarenden kívüli hívások csak akkor kapnak sort, ha ténylegesen van adatuk
    const otherRow = this.toRow('Egyéb', otherCounts);
    if (otherRow.total > 0) {
      this.rows.push(otherRow);
    }

    const totals = this.statuses.map((_, index) =>
      this.rows.reduce((sum, row) => sum + row.counts[index], 0)
    );
    this.totalsRow = this.toRow('Összesen', totals);
  }

  private toRow(label: string, counts: number[]): DailyReportRow {
    return {
      label,
      counts,
      total: counts.reduce((sum, value) => sum + value, 0)
    };
  }

  private formatHourLabel(hour: number): string {
    const pad = (value: number) => value.toString().padStart(2, '0');
    return `${pad(hour)}:00-${pad(hour + 1)}:00`;
  }
}
